// extracted by mini-css-extract-plugin
export default {"containerBadges":"CandidateBadge_containerBadges__rph6S","whiteTxt":"CandidateBadge_whiteTxt__XI28R","yellowTxt":"CandidateBadge_yellowTxt__yhhC+"};